module.exports = __webpack_public_path__ + "img/financialResult_1.77c776b3.png";